"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSessionTypes = exports.getStudentImportStatus = exports.startStudentImport = exports.deleteStudentImportMapping = exports.getStudentImportMapping = exports.getStudentImportMappings = exports.saveStudentImportMapping = exports.PreviewStudentImportFile = exports.UploadStudentImportFile = void 0;
var HttpClient_1 = require("../core/HttpClient");
var UploadStudentImportFile = function (school_id, formData) {
    return HttpClient_1.HttpClient.post("/schools/".concat(school_id, "/student-import/upload"), formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
};
exports.UploadStudentImportFile = UploadStudentImportFile;
var PreviewStudentImportFile = function (school_id, file_id) {
    return HttpClient_1.HttpClient.post("/schools/".concat(school_id, "/student-import/preview"), {
        file_id: file_id,
    });
};
exports.PreviewStudentImportFile = PreviewStudentImportFile;
var saveStudentImportMapping = function (school_id, name, mapping) {
    return HttpClient_1.HttpClient.post("/schools/".concat(school_id, "/student-import/mappings"), {
        school_id: school_id,
        name: name,
        mapping: mapping,
    });
};
exports.saveStudentImportMapping = saveStudentImportMapping;
var getStudentImportMappings = function (school_id) {
    return HttpClient_1.HttpClient.get("/schools/".concat(school_id, "/student-import/mappings"));
};
exports.getStudentImportMappings = getStudentImportMappings;
var getStudentImportMapping = function (school_id, mapping_id) {
    return HttpClient_1.HttpClient.get("/schools/".concat(school_id, "/student-import/mappings/").concat(mapping_id));
};
exports.getStudentImportMapping = getStudentImportMapping;
var deleteStudentImportMapping = function (school_id, mapping_id) {
    return HttpClient_1.HttpClient.delete("/schools/".concat(school_id, "/student-import/mappings/").concat(mapping_id));
};
exports.deleteStudentImportMapping = deleteStudentImportMapping;
var startStudentImport = function (school_id, file_id, test, column_mapping, import_pickup_locations, btw_session_type_id, road_test_session_type_id) {
    return HttpClient_1.HttpClient.post("/schools/".concat(school_id, "/import-students"), {
        school_id: school_id,
        file_id: file_id,
        test: test,
        column_mapping: column_mapping,
        import_pickup_locations: import_pickup_locations,
        btw_session_type_id: btw_session_type_id,
        road_test_session_type_id: road_test_session_type_id,
    });
};
exports.startStudentImport = startStudentImport;
var getStudentImportStatus = function (school_id, import_id) {
    return HttpClient_1.HttpClient.get("/schools/".concat(school_id, "/student-import/").concat(import_id, "/status"));
};
exports.getStudentImportStatus = getStudentImportStatus;
var getSessionTypes = function (school_id) {
    return HttpClient_1.HttpClient.get("/session-types");
};
exports.getSessionTypes = getSessionTypes;
